import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const MoreMenuIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="none"
            viewBox="0 0 24 24"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <circle cx={12} cy={6} r={1} fill="currentColor" />
            <circle cx={12} cy={12} r={1} fill="currentColor" />
            <circle cx={12} cy={18} r={1} fill="currentColor" />
        </svg>
    </IconWrapper>
)
